import { useDispatch } from "react-redux";
import CustomModalAlert from "../../../components/CustomModalAlert";
import CustomDialog from "../../../components/common/dialogs/CustomDialog";
import { Bl } from "../../../interfaces/bl-export/blexport.interface";
import { BLValues } from "../../../interfaces/bl-export/request.bl.interface";
import {
  useGetDetailsBLExportQuery,
  useUpdateBlMutation,
} from "../../../services/bl-export/BLExportService";
import { SkeletonBlForm } from "../forms/CloneBLPreload";
import NewBlFormRF from "../forms/NewBlFormRF";
import { setContainerToUpdate } from "../slices/BlExportSlice";

interface props {
  BlToEdit?: Bl;
  handleClose: () => void;
  refetch: () => void;
}

const EditBl = ({ BlToEdit, handleClose, refetch }: props) => {
  const dispatch = useDispatch();
  const { data, isLoading } = useGetDetailsBLExportQuery(
    {
      id_bl: BlToEdit?.id_bl || "",
      page: 0,
      pageSize: 100,
    },
    {
      skip: Boolean(BlToEdit === undefined),
      refetchOnMountOrArgChange: true,
    }
  );

  // Queries
  const [updateMutation, { isSuccess, reset, error }] = useUpdateBlMutation();

  const blValues: BLValues = {
    id_bl: Number(BlToEdit?.id_bl!),
    cod_booking: BlToEdit?.cod_booking || "",
    dae: BlToEdit?.dae || "",
    formaPago: BlToEdit?.forma_pago || "",
    from: BlToEdit?.from || "",
    hs_code: BlToEdit?.hs_code || "",
    info_consignee: BlToEdit?.info_consignee || "",
    info_notify: BlToEdit?.info_notify || "",
    info_notifya: BlToEdit?.info_notifya || "",
    info_shipper: BlToEdit?.info_shipper || "",
    local_vessel: BlToEdit?.local_vessel || "",
    num_bl: BlToEdit?.num_bl || "",
    ocean_vessel: BlToEdit?.ocean_vessel || "",
    place_delivery: BlToEdit?.place_delivery || "",
    port_descharge: BlToEdit?.port_descharge || "",
    port_loading: BlToEdit?.port_loading || "",
    tipo_bl: BlToEdit?.tipo_bl || "",
    id_cliente:
      BlToEdit?.id_cliente !== undefined
        ? Number(BlToEdit.id_cliente)
        : undefined,
    shipper_reference: BlToEdit?.shipper_reference,
    bl_details:
      data?.detBl?.map((detail) => ({
        tipo_empaque: detail.tipo_empaque,
        cod_contenedor: detail.cod_contenedor,
        commodities: "",
        desc_ad_cont: detail.desc_ad_cont,
        measurement: detail.measurement.toString(),
        num_bultos: detail.num_bultos,
        num_paquetes: detail.num_paquetes,
        peso_bruto: detail.peso_bruto.toString(),
        peso_neto: detail.peso_neto.toString(),
        ref_adicionales: detail.ref_adicionales,
        sellos: detail.sellos,
        id_det_bl: Number(detail.id_det_bl),
      })) || [],
  };

  if (BlToEdit === undefined) {
    return null;
  }

  if (isSuccess) {
    return (
      <CustomModalAlert
        onClose={() => {
          reset();
          handleClose();
          refetch();
          dispatch(setContainerToUpdate(undefined));
        }}
        show={true}
        type="success"
        message="El Bl se ha actualizado correctamente"
      />
    );
  }

  return (
    <>
      <CustomDialog
        handleClose={() => {
          handleClose();
        }}
        isOpen={true}
        title="Editar BL"
        maxWidth="md"
        hideActionButtons
      >
        {isLoading ? (
          <SkeletonBlForm />
        ) : (
          <>
            <NewBlFormRF
              blToEdit={blValues}
              submitAction={(values) => {
                updateMutation(values);
              }}
            />
            {Boolean(error) && (
              <CustomModalAlert
                onClose={reset}
                show={true}
                type="error"
                message={String(error)}
              />
            )}
          </>
        )}
      </CustomDialog>
    </>
  );
};

export default EditBl;
